<template>
  <v-bottom-sheet
    persistent
    :value="value"
    max-width="500px"
  >
    <v-card class="rounded-0 rounded-t-xl py-6 pt-8 px-6">
      <slot />
    </v-card>
  </v-bottom-sheet>
</template>

<script>
export default {
  name: 'FormModal',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
